import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex, Box } from 'rebass'
import HeaderContractedOmniSearchModal from '../HeaderContractedOmniSearchModal'
import HeaderContractedDealershipsModal from '../HeaderContractedDealershipsModal'
import RouterPrimaryExpanded from '../RouterPrimaryExpanded'
import RouterAccount from '../RouterAccount'
import HeaderLogo from '../HeaderLogo'
import { array, number, object } from 'prop-types'
import { SmallToGiantScreenOnly, GiantScreenUp } from '../../utils/style'
import CalltracksPhoneNumber from '../CalltracksPhoneNumber'

const HeaderWrapper = styled(Flex)`
  line-height: 1;
`

const MenuWrapper = styled(Flex)`
  height: 100%;
  align-items: center;
  padding-right: 25px;
`

const MobileMenu = styled(Box)`
  z-index: 4;
  background-color: white;
`

const ContactSmallText = styled(Box)`
  padding-right: 20px;
  font-size: ${rem('13px')};
  letter-spacing: 0.41px;
  line-height: 1;
  align-items: center;
  color: ${(props) => props.theme.colors.grey_light};

  > strong {
    color: ${(props) => props.theme.colors.blue};
  }

  a {
    white-space: nowrap;
    cursor: pointer;
  }

  > a {
    color: ${(props) => props.theme.colors.grey_light};
    text-decoration: none;
  }

  > strong > a {
    color: ${(props) => props.theme.colors.blue};

    &:hover {
      color: ${(props) => props.theme.colors.grey};
    }
  }
`

const HeaderMinimal = ({ sections, phoneNumber, calltracksClass }) => {
  return (
    <HeaderWrapper flexWrap="wrap">
      <Box width={[2 / 12]}>
        <HeaderLogo location="/" />
      </Box>
      <Box width={[7 / 12]}>
        <RouterPrimaryExpanded full sections={sections} max={5} />
      </Box>
      <MobileMenu width={[3 / 12]}>
        <MenuWrapper justifyContent={'flex-end'}>
          <div>
            <SmallToGiantScreenOnly>
              <HeaderContractedDealershipsModal phoneNumber={phoneNumber} />
            </SmallToGiantScreenOnly>
            <GiantScreenUp>
              <ContactSmallText>
                <strong>Call us: </strong>
                <CalltracksPhoneNumber
                  phoneNumber={phoneNumber}
                  calltracksClass={calltracksClass}
                />
              </ContactSmallText>
            </GiantScreenUp>
          </div>
          <HeaderContractedOmniSearchModal minimal wide />
          <RouterAccount nofavouritesicon favourites={4} />
        </MenuWrapper>
      </MobileMenu>
    </HeaderWrapper>
  )
}

HeaderMinimal.defaultProps = {
  sections: [],
  subSections: [],
  max: 3,
  brands: []
}

HeaderMinimal.propTypes = {
  sections: array,
  subSections: array,
  max: number,
  brands: array,
  phoneNumber: object
}

export default HeaderMinimal
